export const SUPPORT_ASSISTANT_POLICY_REQUIRED =
  'AI policy must be accepted before using the support assistant';

export const canAskSupportAssistant = (args: {
  policyLoading: boolean;
  needsAcceptance: boolean;
}): boolean => {
  return !args.policyLoading && !args.needsAcceptance;
};
